import type { IntegrationSuggestion } from '@/features/integrations/integrations.types';
import { IntegrationIcon } from '@/integrations/integration-icon';
import { cn } from '@/lib/utils';

export const SuggestionIcon = ({
  suggestion,
  className,
}: {
  suggestion: IntegrationSuggestion;
  className?: string;
}) => (
  // A custom MCP server has no brand icon; its monogram comes from its name, as on the Integrations page
  <IntegrationIcon
    iconKey={suggestion.toolkit_slug}
    iconUrl={suggestion.icon_url}
    name={suggestion.display_name}
    className={cn('size-4 rounded', className)}
  />
);
